import store from '../../store';
import Notify from 'quasar/src/plugins/Notify.js';;
import { sortBy } from 'lodash';
const executionAction = (action) => {
    if (action.actionType === 'store-dispatch') {
        const actionName = action.actionName; // this allows passing multiple actions of same 'store-dispatch' type.  that's useful for repeatFetch actions on multiple modules. Or when payload is same on processPartialRefresh action on multiple modules
        if (Array.isArray(actionName)) {
            actionName.forEach(aName => store.dispatch(aName, action.payload));
        }
        else {
            store.dispatch(actionName, action.payload);
        }
    }
    else if (action.actionType === 'show-notification') {
        Notify.create(action); // action object is expected to have notification object attributes message, color, etc as needed
    }
    else if (action.actionType === 'save-to-local-storage') {
        for (const key in action.keyValuesPairs) {
            localStorage.setItem(key, action.keyValuesPairs[key]);
        }
    }
    else if (action.actionType === 'save-to-session-storage') {
        for (const key in action.keyValuesPairs) {
            sessionStorage.setItem(key, action.keyValuesPairs[key]);
        }
    }
    else if (action.actionType === 'change-window-location') {
        window.location.assign(action.url);
    }
    else if (action.actionType === 'open-new-window-location') {
        window.open(action.url);
    }
    else if (action.actionType === 'open-window-location') {
        window.location.href = action.url;
    }
};
export default function (requestedActions) {
    const actions = sortBy(requestedActions, 'executionOrder');
    const lastIndex = actions.length - 1;
    const runIteration = (i) => {
        executionAction(actions[i]);
        if (i < lastIndex)
            setTimeout(() => runIteration(i + 1), actions[i + 1].timeout || 0);
    };
    runIteration(0);
}
